import React from 'react';

const Free = () => {
    return (
        <div>
            <h1>Here will be the pricing list and card with access rates for free</h1>
        </div>
    )
}

export default Free;